import {
  useModalContext,
  WSAmountInput,
  WSButton,
  WSButtons,
  WSElement,
  WSForm,
  WSModal,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useCreateBankingPendingTransaction } from "../../query/bookkeeping/mutations";
import * as Yup from "yup";
import { Currency } from "@wingspanhq/users/dist/lib/interfaces";
import { PendingTransactionSubType } from "@wingspanhq/bookkeeping/dist/lib/interfaces/pendingTransaction";
import { WSQuery } from "../../query/WSQuery";
import { useBankingBalance } from "../../query/bookkeeping/queries";
import { formatMoney } from "accounting";
import { validatorAmount } from "../../utils/validators";
import { InternalAccountType } from "@wingspanhq/bookkeeping/dist/lib/interfaces/internalAccount";
import { WSErrorMessage } from "../../components/WSErrorMessage/WSErrorMessage";
import { CurrencyUSD } from "../../services/bookkeeping";

export const WITHDRAW_FUNDS_MODAL = "WITHDRAW_FUNDS_MODAL";

export const WithdrawFundsModal: React.FC = () => {
  const { closeModal } = useModalContext();

  const [
    createTransaction,
    metaCreateTransaction
  ] = useCreateBankingPendingTransaction();

  const qBankingBalance = useBankingBalance();

  return (
    <WSModal
      name={WITHDRAW_FUNDS_MODAL}
      size="S"
      onClose={() => closeModal(WITHDRAW_FUNDS_MODAL)}
    >
      <WSQuery query={qBankingBalance}>
        {({ data: { balance } }) => (
          <WSElement p="S">
            <WSText.Heading2 mb="M">Withdraw Funds</WSText.Heading2>

            <WSForm
              defaultValues={{
                amount: ""
              }}
              validationSchema={Yup.object().shape({
                amount: validatorAmount(balance)
              })}
              onSubmit={async formData => {
                await createTransaction(
                  {
                    amount: parseFloat(formData.amount) || 0,
                    currency: CurrencyUSD,
                    subType: PendingTransactionSubType.Withdraw,
                    type: InternalAccountType.Banking
                  },
                  {
                    throwOnError: true
                  }
                );

                closeModal(WITHDRAW_FUNDS_MODAL);
              }}
            >
              {({ setValue, getValues }) => (
                <>
                  <WSForm.Field
                    mb="M"
                    label="Dollar amount"
                    name="amount"
                    component={WSAmountInput}
                    componentProps={{
                      prefix: "$",
                      allowNegative: false,
                      onBlur: () =>
                        setValue(
                          "amount",
                          getValues("amount") === ""
                            ? ""
                            : Number(getValues("amount")).toFixed(2)
                        )
                    }}
                  />

                  <WSText.Label align="center" color="grey600">
                    {formatMoney(balance)} available
                  </WSText.Label>

                  <WSErrorMessage
                    mt="M"
                    error={metaCreateTransaction.error}
                    contextKey="PendingWithholding"
                  />

                  <WSButtons mt="XL" forceFullWidth>
                    <WSForm.SubmitButton>Withdraw</WSForm.SubmitButton>
                    <WSButton.Tertiary
                      onClick={() => closeModal(WITHDRAW_FUNDS_MODAL)}
                    >
                      Cancel
                    </WSButton.Tertiary>
                  </WSButtons>
                </>
              )}
            </WSForm>
          </WSElement>
        )}
      </WSQuery>
    </WSModal>
  );
};
